import { MutationTree } from "vuex";
import {
  IApprovalDelegation,
  IApprovalRequestDetail,
  IApprovalRequestListItem,
  IApprovalRequestsState,
} from "../types";

const mutations: MutationTree<IApprovalRequestsState> = {
  setApprovalRequests(state, payload: IApprovalRequestListItem[]) {
    state.approvalRequests = payload;
  },
  setSelectedApprovalRequest(state, payload: IApprovalRequestDetail | null) {
    state.selectedApprovalRequest = payload;
  },
  setTotalRecords(state, payload: number) {
    state.totalRecords = payload;
  },
  setPage(state, payload: number) {
    state.page = payload;
  },
  setPageSize(state, payload: number) {
    state.pageSize = payload;
  },
  setFetchingApprovalRequests(state, payload: boolean) {
    state.isFetchingApprovalRequests = payload;
  },
  setFetchingApprovalRequestDetail(state, payload: boolean) {
    state.isFetchingApprovalRequestDetail = payload;
  },
  setApprovalRequestActionLoading(state, payload: boolean) {
    state.isApprovalRequestActionLoading = payload;
  },
  setApprovalDelegations(state, payload: IApprovalDelegation[]) {
    state.approvalDelegations = payload;
  },
  setAssignedApprovalDelegations(state, payload: IApprovalDelegation[]) {
    state.assignedApprovalDelegations = payload;
  },
  setFetchingApprovalDelegations(state, payload: boolean) {
    state.isFetchingApprovalDelegations = payload;
  },
  setFetchingAssignedApprovalDelegations(state, payload: boolean) {
    state.isFetchingAssignedApprovalDelegations = payload;
  },
  setApprovalDelegationActionLoading(state, payload: boolean) {
    state.approvalDelegationActionLoading = payload;
  },
};

export default mutations;
